module.exports = __webpack_public_path__ + "img/24.1863cda4.jpg";